import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../App.css";

import hydroponics_shop_nft from "../../Assets/hydroponics_shop_nft.webp";
import hydroponics_systems_growslab from "../../Assets/hydroponics_systems_growslab.webp";
import hydroponics_systems_dutch_bucket1 from "../../Assets/hydroponics_systems_dutch_bucket1.webp";
import growbag_shop1 from "../../Assets/growbag_shop1.webp";
import hydroponics_systems_net_pots1 from "../../Assets/hydroponics_systems_net_pots1.webp";
import Growing_tray_for_microgreens1 from "../../Assets/Growing tray for microgreens or Fodder tray1.webp";
import Oasis_cube_shop1 from "../../Assets/oasis_cube_shop1.webp";

import CartModal from "../../Components/CartModal";

function Hydroponic_systems_shop() {
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const products = [
    {
      id: 81,
      name: "NFT",

      image: hydroponics_shop_nft,
      link: "/Nft-shop",
      description: "Description for Product 2",
    },
    {
      id: 82,
      name: "Growslab",

      image: hydroponics_systems_growslab,
      link: "/Growslab-shop",
      description: "Description for Product 2",
    },
    {
      id: 83,
      name: "Dutch bucket",

      image: hydroponics_systems_dutch_bucket1,
      link: "/Dutch-bucket-shop",
      description: "Description for Product 2",
    },
    {
      id: 84,
      name: "Grow bag",

      image: growbag_shop1,
      link: "/Grow-bag-shop",
      description: "Description for Product 2",
    },
    {
      id: 85,
      name: "Net Pots",

      image: hydroponics_systems_net_pots1,
      link: "/Net-pots-shop",
      description: "Description for Product 2",
    },
    {
      id: 86,
      name: "Growing tray for microgreens/Fodder tray",

      image: Growing_tray_for_microgreens1,
      link: "/Growing-tray-for-microgreens-shop",
      description: "Description for Product 2",
    },
    {
      id: 87,
      name: "Oasis cube",

      image: Oasis_cube_shop1,
      link: "/Oasis-cube-shop",
      description: "Description for Product 2",
    },
  ];
  const itemsPerPage = 12;
  const totalPages = Math.ceil(products.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const currentProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <Container>
      <Row>
        {currentProducts.map((product) => (
          <Col key={product.id} xs={12} sm={6} md={3}>
            <Link
              to={product.link}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Card className="product-card">
                <Card.Img
                  variant="top"
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <Card.Body>
                  <Card.Title className="text-center">
                    {product.name}
                  </Card.Title>

                  <Card.Text>
                    <Link to="/Contact" className="btn btn-link">
                      Contact Us for the Price Details
                    </Link>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </Container>
  );
}
export default Hydroponic_systems_shop;
